<template>
  <div class="tw-relative tw-group">
    <img :src="imageUrl" class="tw-w-full" :class="imageClass" alt="Image Preview">
    <a :href="assetUrl"
      class="tw-border-0 tw-p-0 tw-invisible group-hover:tw-visible tw-absolute tw-inset-0">
      <slot></slot>

      <span class="tw-absolute tw-inset-0 group-hover:tw-visible tw-bg-black tw-bg-opacity-[65%] tw-rounded-lg tw-pointer-events-none"></span>
    </a>

    <div class="tw-absolute tw-left-0 tw-right-0 tw-bottom-0 tw-max-w-full tw-pointer-events-none">
      <slot name="bottom-left"></slot>
    </div>

    <div class="tw-absolute tw-right-0 tw-top-0 tw-left-0 tw-max-w-full tw-pointer-events-none">
      <slot name="top-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'imageUrl',
    'assetUrl',
    'imageClass'
  ]
}
</script>